import { render, staticRenderFns } from "./SignUpPagePassword.vue?vue&type=template&id=3011b03e&scoped=true&"
import script from "./SignUpPagePassword.vue?vue&type=script&lang=js&"
export * from "./SignUpPagePassword.vue?vue&type=script&lang=js&"
import style0 from "./SignUpPagePassword.vue?vue&type=style&index=0&id=3011b03e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011b03e",
  null
  
)

export default component.exports